(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('StateListController', StateListController);
    

    StateListController.$inject = [
        '$scope',
        'estadosOperarioService',
        'ModalService', 
        '$templateCache', 
        'genericDataService',
        'common', 
        'notificationService',
        '$state', 
        'restrictionService'


    ];

    function StateListController($scope, estadosOperarioService, ModalService, $templateCache, genericDataService, common, notificationService, $state, restrictionService) {

        var modalTemplate = $templateCache.get('app/views/modals/estadoOperarioTemplate.html');

     
        var vm = this;
        vm.restrictionService = restrictionService; 
        vm.initialResult = [];
        vm.elements = []; 

        vm.addState = addState;
        vm.showModal = showModal; 
        vm.save = save;
        vm.remove = remove;
        vm.addEstadoOperario = addEstadoOperario;
        vm.refresh = refresh; 

        //substituir por el dragdrop
        vm.up = up; 
        vm.down = down; 
        



        (function () {
            loadData();

        })();

        function loadData() {
            estadosOperarioService.getList()
                .then(function (result) {
                    vm.initialResult = result.data.list;
                    vm.elements = result.data.list; 

                });

        }

        function addState() {
            if (!restrictionService.hasPermission('crear', 'estadoOperario')) return; 

            showModal(); 
        }

        function showModal(estadoOperario) {
            if (!restrictionService.hasPermission('crear', 'estadoOperario')) return; 

            ModalService.showModal({
                template: modalTemplate,
                controller: function ($scope, close) {
                    var modal = this;
                    modal.vm = vm;
                    modal.isEdit = false; 
                    modal.estadoOperario = {};
                    modal.colores = {
                        list: [],
                        selected: {}
                    };

                    modal.estadoOperario = {}; 

                    modal.load = function () {
                        genericDataService.getColoresEstado()
                            .then(function (res) {
                                modal.colores.list = res.data;

                                if (modal.estadoOperario.colorEstadoId == null) {
                                    modal.colores.selected = modal.colores.list[0];
                                }
                                else {
                                    modal.colores.selected = modal.colores.list.find(el => el.colorEstadoId == modal.estadoOperario.colorEstadoId);

                                }
                            });
                    };

                    modal.saveClose = function () {
                        if (modal.estadoOperario.descripcion != null) {
                            modal.estadoOperario.colorEstadoId = modal.colores.selected.colorEstadoId; 
                            modal.estadoOperario.colorEstado = modal.colores.selected;
                            vm.addEstadoOperario(modal.estadoOperario, modal.isEdit);
                            close(modal.estadoOperario);
                        }
                    };

                    modal.close = function () {
                        close();
                    };

                    if (estadoOperario) {
                        modal.isEdit = true;
                        modal.estadoOperario = Object.assign({}, estadoOperario);
                    } else {
                        modal.estadoOperario = {};
                    }

                    modal.load(); 
                },
                controllerAs: 'modal'
            });
        }

        function addEstadoOperario(obj, edit) {
            if (edit) {
                var indx = vm.elements.findIndex(x => x.estadoOperarioId == obj.estadoOperarioId);
                if (indx) {
                    vm.elements[indx] = obj; 
                }
            
            }
            else { //new
                var estadoOperarioIdTemp = 101;
                if (vm.elements.length > 0) {
                    estadoOperarioIdTemp = vm.elements[vm.elements.length - 1].estadoOperarioId + 1;
                }
                var temp = 
                {
                    estadoOperarioId : estadoOperarioIdTemp,
                    descripcion : obj.descripcion,
                    colorEstadoId: obj.colorEstadoId,
                    colorEstado: obj.colorEstado
                }
                vm.elements.push(temp); 
              
            }
        }

        //guarda y recarga pagina
        function save() {
            estadosOperarioService.add(vm.elements).then(function (result) {
                sendSAveNotification(); 
                $state.go('flota.configuracion.general');
            });
               
        }

        function refresh() {
            loadData();
        }

        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'Los estados de operario se han guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }


        function up(obj) {
            changePosition(obj, 0);
        }

        function down(obj) {
            changePosition(obj, 1); 
        }

        //mode = 0 up, mode = 1 down
        function changePosition(obj, mode) {
            var it = 0;
            var found = false;
            while (it < vm.elements.length && !found) {
                if (vm.elements[it] == obj) found = true;
                else ++it;  
            }
            if (found) {
                if (mode === 0 && it != 0) {
                    var tempId = vm.elements[it - 1].estadoOperarioId; 
                    var tempObj = vm.elements[it - 1];
                    vm.elements[it - 1] = obj; 
                    vm.elements[it] = tempObj;
                    vm.elements[it].estadoOperarioId = obj.estadoOperarioId;
                    vm.elements[it - 1].estadoOperarioId = tempId; 
                }
                else if (mode === 1 && it != (vm.elements.length - 1)) {
                    var tempId = vm.elements[it + 1].estadoOperarioId;
                    var tempObj = vm.elements[it + 1];
                    vm.elements[it + 1] = obj;
                    vm.elements[it] = tempObj;
                    vm.elements[it].estadoOperarioId = obj.estadoOperarioId;
                    vm.elements[it + 1].estadoOperarioId = tempId; 
                }

            }
        }
        function remove(estadoOperario) {
            if (!restrictionService.hasPermission('eliminar', 'estadoOperario')) return; 

            var i = findByProperty(vm.elements, 'estadoOperarioId', estadoOperario.estadoOperarioId);
            if (i) {
                vm.elements.splice(i, 1);
            }
        }

        //returns postion in the array
        function findByProperty(array, property, id) {
            if (array === null) { return null; }
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return i;
                }
            }
            return null;
        }
    }

})();